import { Fragment } from 'react';
import styled from 'styled-components';
import { Group as GroupType, MergedPermission } from 'modules/roles/types';
import { colors, H3, spacing, Subtitle1 } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { CheckboxField } from './CheckboxField';

const Container = styled.div``;

const GroupHeading = styled(H3)`
  padding-bottom: ${spacing.base};
  margin-bottom: ${spacing.base};
  border-bottom: ${spacing.single} solid ${colors.grey15};
`;

const Section = styled.section`
  & ~ & {
    margin-top: ${spacing.double};
  }

  @media (min-width: ${pxToRem(720)}) {
    display: grid;
    grid-template-columns: minmax(${pxToRem(200)}, 1fr) 3fr;
  }
`;

const CategoryWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media (max-width: ${pxToRem(720 - 1)}) {
    row-gap: ${spacing.half};
  }
`;

const ChildContainer = styled.div`
  padding-left: ${spacing.plusHalf};
`;

type Props = GroupType & {
  getPermissionById: (id: number) => MergedPermission | undefined;
  handleChange: (id: number) => void;
  id: string;
  selectedPermissions: number[];
};

export const Group = ({
  getPermissionById,
  handleChange,
  id,
  name,
  categories,
  selectedPermissions,
}: Props) => {
  return (
    <Container>
      <GroupHeading id={id}>{name}</GroupHeading>
      {categories?.map((category) => (
        <Section key={category.id}>
          <Subtitle1>{category.name}</Subtitle1>
          <CategoryWrapper>
            {category.permissions.map((permission, index) => {
              const current = getPermissionById(permission);
              return (
                <Fragment key={current?.id || index}>
                  <CheckboxField
                    currentState={selectedPermissions}
                    handleChange={handleChange}
                    permission={current}
                  />
                  {current?.children?.length && (
                    <ChildContainer>
                      {current.children.map((childId, childIndex) => {
                        const currentChild = getPermissionById(childId);
                        return (
                          <CheckboxField
                            currentState={selectedPermissions}
                            handleChange={handleChange}
                            key={currentChild?.id || childIndex}
                            permission={currentChild}
                          />
                        );
                      })}
                    </ChildContainer>
                  )}
                </Fragment>
              );
            })}
          </CategoryWrapper>
        </Section>
      ))}
    </Container>
  );
};
